import React from "react";
import { CiMail } from "react-icons/ci";
import "./Contact.css";
const Contact = () => {
  return (
    <div id="contact" className="bg-contact py-5">
      <div>
        <div className="grid lg:grid-cols-2 gap-5">
          <div className="flex items-center justify-center">
            <div>
              <h1 className="text-5xl max-w-md text-secondary">
                Let's chat . Tell me about your Project.
              </h1>
              <p className="text-accent text-xl my-5">
                Let's create something together 🤟
              </p>

              <span className="flex items-center">
                <span className="bg-neutral py-3 px-4 rounded-md mr-5">
                  <CiMail className="text-primary text-4xl" />
                </span>
                <span>
                  <p className="text-accent">Mail me at</p>
                  <p className="text-primary">akraj2270@gmail.com</p>
                </span>
              </span>
            </div>
          </div>
          <div>
            <div className="card mx-auto flex-shrink-0 w-full max-w-sm shadow-2xl bg-neutral">
              <div className="card-body">
                <h2 className="text-xl">Send us a message 🚀</h2>
                <form action="https://formspree.io/f/xknavzdw" method="POST">
                  <div className="form-control">
                    <input
                      type="text"
                      name="name"
                      placeholder="Full name*"
                      className="input input-bordered"
                      required
                    />
                  </div>
                  <div className="form-control">
                    <input
                      name="email"
                      type="email"
                      placeholder="Email address*"
                      className="input input-bordered my-2"
                      required
                    />
                  </div>
                  <div className="form-control">
                    <input
                      name="submit"
                      type="text"
                      placeholder="Subject*"
                      className="input input-bordered"
                      required
                    />
                  </div>
                  <div className="form-control">
                    <label className="label">
                      <span className="label-text">
                        Tell us more about your project*
                      </span>
                    </label>
                    <textarea
                      name="text"
                      className="textarea textarea-bordered"
                      required
                    ></textarea>
                  </div>
                  <div className="form-control mt-6">
                    <input
                      className="btn btn-primary"
                      type="submit"
                      value="send message"
                    />
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contact;
